import React, { useState, useContext } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Archive from '../components/Archive/Archive';
import ShipmentManagement from '../components/ShipmentManagement/ShipmentManagement';
import NowlunPopeye from '../components/Popeye/Popeye';
import { Spin } from 'antd';
import Header from '../components/Header/Header';

// RedirectToRoot Component
const RedirectToRoot = () => {
  let location = useLocation();
  window.location.href = `${process.env.REACT_APP_ROOT_HOST}${location.pathname}`;
  return <Spin className="spinner" size="large" />;
};

// AppRoutes Component
const AppRoutes = () => {
  const location = useLocation();
  const shouldHideHeader = location.pathname === '/shipment_management/popeye' || location.pathname === '/shipment_management/now_sync' || location.pathname === '/now_sync' || location.pathname === '/popeye';


  return (
    <>
      {!shouldHideHeader && <Header />}
      <Routes>
        <Route path="/shipment_management" element={<ShipmentManagement />} />
        <Route path="/shipment_management/explore" element={<ShipmentManagement />} />
        <Route path="/shipment_management/archive" element={<Archive />} />
        <Route path="/shipment_management/popeye" element={<NowlunPopeye />} />
        <Route path="/shipment_management/now_sync" element={<NowlunPopeye />} />
        <Route path="/shipments/search" element={<RedirectToRoot />} />
        <Route path="/notifications" element={<RedirectToRoot />} />
        <Route path="*" element={<RedirectToRoot />} />
      </Routes>
    </>
  );
};

// Index Component
const Index = () => (
  <Router>
    <AppRoutes />
  </Router>
);

export default Index;
